import { type PropsWithChildren, type ReactNode } from 'react';

import { AccordionItem } from '#/components/Accordion/Item/AccordionItem';
import { DropdownChevron } from '#/components/Dropdown/Chevron/DropdownChevron';
import { Icon } from '#/components/Icon/Icon';
import type { IconName } from '#/components/Icon/IconName';
import type { SearchRefinementType } from '#/modules/search/constants/refinements/searchRefinementTypes';
import { useSearchAnalytics } from '#/modules/search/hooks/useSearchAnalytics';
import { trackEvent } from '#/utils/analytics/track/trackEvent';

import {
  SearchDateRangeAccordionSummary,
  SearchDateRangeAccordionSummaryLabel,
} from './SearchDateRangeAccordionItem.styled';

type Props = {
  facetType: SearchRefinementType;
  label: ReactNode;
  icon?: IconName;
};

export function SearchDateRangeAccordionItem({
  children,
  facetType,
  icon,
  label,
}: PropsWithChildren<Props>) {
  const { getSearchTrackingData } = useSearchAnalytics();

  return (
    <AccordionItem
      onToggle={(open) =>
        open
          ? trackEvent('Expanded Search Filter', {
              filter_name: facetType,
              ...getSearchTrackingData(),
            })
          : undefined
      }
      qaId={`search-facet-accordion-item-${facetType}`}
      name="search-facet"
      header={
        <SearchDateRangeAccordionSummary>
          <SearchDateRangeAccordionSummaryLabel>
            {icon ? <Icon size={18} name={icon} /> : undefined}
            <span>{label}</span>
          </SearchDateRangeAccordionSummaryLabel>
          <DropdownChevron size={16} />
        </SearchDateRangeAccordionSummary>
      }
    >
      <div data-facet-type={facetType}>{children}</div>
    </AccordionItem>
  );
}
